(() => {
  if (customElements.get('vsz-dobry-sort')) return;
  class DobrySort extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.form = this.querySelector('[data-book-form]');
      this.variant = this.form.querySelector('[name="id"]');
      this.formatInputs = [...this.form.querySelectorAll('[data-offer-kind]')];
      this.group = this.querySelector('[data-group-id]');
      this.video = this.querySelector('[data-video-id]');
      this.personalization = this.querySelector('[data-personalization]');
      this.button = this.querySelector('[data-buy-button]');
      this.status = this.querySelector('[data-form-status]');
      this.defaultLabel = this.button.textContent;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.variant.addEventListener('change', () => this.updatePrice(), options);
      this.formatInputs.forEach(input => {
        input.addEventListener('change', () => this.updatePrice(), options);
        input.addEventListener('change', () => this.togglePersonalization(), options);
      });
      if (this.personalization) {
        this.personalization.hidden = true;
      }
      this.video?.addEventListener('change', () => this.updatePrice(), options);
      this.form.addEventListener('submit', event => this.addToCart(event), options);

      [...this.querySelectorAll('[data-start-personalizacja]')].forEach(link => {
        link.addEventListener('click', event => {
          const target = link.getAttribute('href');
          const targetId = target && target.startsWith('#') ? target.slice(1) : '';
          const targetElement = targetId ? this.ownerDocument.getElementById(targetId) : null;
          if (!targetElement) return;
          event.preventDefault();
          this.openPersonalization(targetElement);
        }, options);
      });

      this.updatePrice();
      this.initMotion(options);
      this.initConfigurator(options);
      this.initPromoClock(options);

      if (window.location.hash === `#${this.id}-personalizacja`) {
        const targetElement = this.ownerDocument.getElementById(`${this.id}-personalizacja`);
        if (targetElement) this.openPersonalization(targetElement);
      }
      if ('IntersectionObserver' in window) {
        this.pillarObserver = new IntersectionObserver(entries => entries.forEach(entry => entry.target.classList.toggle('ds-pillar-playing', entry.isIntersecting)), {threshold: .25});
        this.querySelectorAll('[data-pillar-motion]').forEach(el => this.pillarObserver.observe(el));
      }
    }
    disconnectedCallback() {
      this.closeConfigurator();
      this.controller?.abort();
      this.revealObserver?.disconnect();
      this.pillarObserver?.disconnect();
      clearTimeout(this.promoTimer);
      if (this.scrollFrame) cancelAnimationFrame(this.scrollFrame);
      this.ready = false;
    }
    initConfigurator(options) {
      const startInConfigurator = this.personalization && this.personalization.closest('[data-configurator]');
      if (startInConfigurator) return;
      this.dialog = this.querySelector('[data-configurator]');
      if (!this.dialog || typeof this.dialog.showModal !== 'function') return;
      this.formHome = document.createComment('Dobry Sort form position');
      this.form.before(this.formHome);
      this.querySelectorAll(`a[href="#${this.id}-kup"]`).forEach(link => {
        link.addEventListener('click', event => {
          event.preventDefault();
          this.configOpener = link;
          this.querySelector('[data-config-form-slot]').append(this.form);
          this.dialog.showModal();
          this.oldBodyOverflow = document.body.style.overflow;
          document.body.style.overflow = 'hidden';
        }, options);
      });
      this.querySelector('[data-config-close]').addEventListener('click', () => this.dialog.close(), options);
      this.dialog.addEventListener('close', () => this.closeConfigurator(), options);
      this.dialog.addEventListener('click', event => { if (event.target === this.dialog) this.dialog.close(); }, options);
    }
    openPersonalization(target) {
      this.form?.classList.add('ds-choice-open');
      if (this.personalization) this.personalization.hidden = false;
      if (this.dialog && typeof this.dialog.showModal === 'function' && this.form && !this.dialog.contains(this.form)) {
        this.querySelector('[data-config-form-slot]')?.append(this.form);
        this.dialog.showModal();
        this.oldBodyOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
      }
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      this.togglePersonalization();
    }
    togglePersonalization() {
      if (!this.personalization) return;
      this.personalization.hidden = false;
      this.updatePrice();
    }
    closeConfigurator() {
      if (this.formHome && this.form && this.dialog?.contains(this.form)) {
        if (this.dialog.open) this.dialog.close();
        this.formHome.after(this.form);
        document.body.style.overflow = this.oldBodyOverflow || '';
        this.configOpener?.focus({ preventScroll: true });
      }
    }
    initMotion(options) {
      const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
      const toggle = null;
      const stage = this.querySelector('.ds-cover-stage');
      const story = this.querySelector('[data-scroll-story]');
      const frames = [...this.querySelectorAll('[data-story-frame]')];
      const copies = [...this.querySelectorAll('[data-story-copy]')];
      const dots = [...this.querySelectorAll('[data-scene-dot]')];
      const navItems = [...this.querySelectorAll('.ds-section-nav a')].map(link => ({link, target:this.querySelector(link.getAttribute('href'))}));
      let manuallyPaused = false;
      const applyPreference = () => {
        const paused = preference.matches || manuallyPaused;
        this.classList.toggle('ds-motion-paused', paused);
        this.classList.toggle('ds-story-enhanced', !paused);
        if (paused) [...frames, ...copies].forEach(el => { el.style.removeProperty('transform'); el.style.removeProperty('opacity'); el.removeAttribute('aria-hidden'); });
        if (toggle) {
          toggle.hidden = false;
          toggle.disabled = preference.matches;
          toggle.setAttribute('aria-pressed', String(paused));
        }
      };
      toggle?.addEventListener('click', () => { manuallyPaused = !manuallyPaused; applyPreference(); }, options);
      preference.addEventListener('change', applyPreference, options);
      applyPreference();
      this.classList.add('ds-motion-ready');
      if ('IntersectionObserver' in window) {
        this.revealObserver = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              entry.target.classList.add('ds-in-view');
              this.revealObserver.unobserve(entry.target);
            }
          });
        }, { threshold: 0.04, rootMargin: '0px 0px -20px 0px' });
        this.querySelectorAll('.ds-section:not(.ds-split), .ds-proof, .ds-feature-card, .ds-benefit-hitlist article, .ds-premium-grid p, .ds-outcome-grid p, .ds-outcome-grid article').forEach(section => {
          if (section.getBoundingClientRect().top > window.innerHeight) section.classList.add('ds-reveal');
          this.revealObserver.observe(section);
        });
      }
      const progress = this.querySelector('.ds-reading-progress span');
      const hero = this.querySelector('.ds-hero');
      const parallax = [...this.querySelectorAll('.ds-story-photo, .ds-chat-art, .ds-video-photo')];
      const updateProgress = () => {
        this.scrollFrame = 0;
        const rect = this.getBoundingClientRect();
        const range = Math.max(1, rect.height - window.innerHeight);
        const value = Math.max(0, Math.min(1, -rect.top / range));
        if (progress) progress.style.transform = `scaleX(${value})`;
        this.classList.toggle('ds-buybar-visible', !!hero && hero.getBoundingClientRect().bottom < 150);
        let current = null;
        navItems.forEach(item => { if (item.target && item.target.getBoundingClientRect().top <= 220) current = item.link; });
        navItems.forEach(item => { if (item.link === current) item.link.setAttribute('aria-current','location'); else item.link.removeAttribute('aria-current'); });
        if (this.classList.contains('ds-motion-paused')) return;
        if (story) {
          const sr = story.getBoundingClientRect();
          const offset = innerWidth < 750 ? 112 : 95;
          const range = Math.max(1, sr.height - window.innerHeight + offset);
          const position = Math.max(0, Math.min(1, (offset - sr.top) / range)) * 2;
          frames.forEach((frame, index) => {
            const distance = index - position;
            frame.style.transform = `translate3d(${distance * 9}%,${-distance * 118}%,0) rotate(${distance * -11}deg) scale(${1 - Math.min(Math.abs(distance),1) * .12})`;
            frame.style.opacity = String(Math.max(0, 1 - Math.abs(distance) * 1.18));
            frame.setAttribute('aria-hidden', String(Math.abs(distance) > .5));
          });
          copies.forEach((copy, index) => {
            const distance = index - position;
            copy.style.opacity = String(Math.max(0, 1 - Math.abs(distance) * 1.7));
            copy.style.transform = `translateY(${distance * 65}px)`;
            copy.setAttribute('aria-hidden', String(Math.abs(distance) > .5));
          });
          dots.forEach((dot,index) => dot.classList.toggle('is-active',index === Math.round(position)));
        }
        if (hero && stage) {
          const hr = hero.getBoundingClientRect();
          const position = Math.max(0, Math.min(1, -hr.top / hr.height));
          stage.style.setProperty('--ds-book-y', `${position * 100}px`);
          stage.style.setProperty('--ds-book-turn', `${position * 58}deg`);
          stage.style.setProperty('--ds-book-roll', `${position * 19}deg`);
          stage.style.setProperty('--ds-witek-y', `${position * -135}px`);
        }
        parallax.forEach(art => {
          const ar = art.getBoundingClientRect();
          if (ar.bottom < -100 || ar.top > window.innerHeight + 100) return;
          const position = Math.max(-1, Math.min(1, (ar.top + ar.height / 2 - window.innerHeight / 2) / window.innerHeight));
          art.style.setProperty('--ds-parallax-y', `${position * 32}px`);
          art.style.setProperty('--ds-parallax-r', `${-3 + position * 7}deg`);
        });
      };
      window.addEventListener('scroll', () => {
        if (!this.scrollFrame) this.scrollFrame = requestAnimationFrame(updateProgress);
      }, { ...options, passive: true });
      window.addEventListener('resize', updateProgress, options);
      updateProgress();
      if (stage && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
        stage.addEventListener('pointermove', event => {
          if (this.classList.contains('ds-motion-paused')) return;
          const r = stage.getBoundingClientRect();
          stage.style.setProperty('--ds-tilt-x', `${((event.clientY - r.top) / r.height - .5) * -16}deg`);
          stage.style.setProperty('--ds-tilt-y', `${((event.clientX - r.left) / r.width - .5) * 28}deg`);
        }, options);
        stage.addEventListener('pointerleave', () => {
          stage.style.setProperty('--ds-tilt-x', '0deg');
          stage.style.setProperty('--ds-tilt-y', '0deg');
        }, options);
      }
    }
    selected() {
      return this.variant.tagName === 'SELECT' ? this.variant.selectedOptions[0] : this.variant;
    }
    selectedOffer() {
      const isMentor = this.formatInputs.some(input => input.checked && input.value === 'mentor');
      const selected = isMentor ? this.group : this.selected();
      return {isMentor, selected};
    }
    initPromoClock(options) {
      const expiry = Number(this.dataset.videoEnd) * 1000;
      const check = () => {
        clearTimeout(this.promoTimer);
        if (this.dataset.videoState === 'free' && expiry > 0 && Date.now() >= expiry) {
          this.button.disabled = true;
          this.status.textContent = 'Promocja na film się zakończyła. Odśwież stronę, żeby zobaczyć aktualne opcje.';
          this.dataset.promoExpired = 'true';
          const link = document.createElement('a');
          link.href = window.location.href;
          link.textContent = ' Odśwież stronę';
          this.status.append(link);
        } else if (this.dataset.videoState === 'free' && expiry > Date.now()) {
          this.promoTimer = setTimeout(check, Math.min(expiry - Date.now() + 100, 2147483647));
        }
      };
      if (this.dataset.videoState === 'free' && expiry > Date.now()) {
        check();
        document.addEventListener('visibilitychange', () => { if (!document.hidden) check(); }, options);
      }
    }
    money(cents) {
      return new Intl.NumberFormat(this.dataset.locale || 'pl', {
        style: 'currency', currency: this.dataset.currency || 'PLN'
      }).format(cents / 100);
    }
    updatePrice() {
      const { selected, isMentor } = this.selectedOffer();
      const amount = Number(selected?.dataset.price || 0);
      const bookAmount = Number(this.selected()?.dataset.price || 0);
      const available = selected?.dataset.available === 'true' && this.dataset.purchaseAllowed === 'true' && this.dataset.promoExpired !== 'true';
      const videoAddition = this.video?.checked && !this.video.disabled ? Number(this.video.dataset.videoPrice) : 0;
      this.querySelectorAll('[data-book-price]').forEach(el => { el.textContent = this.money(bookAmount); });
      this.querySelectorAll('[data-offer-price]').forEach(el => { el.textContent = this.money(amount); });
      this.querySelectorAll('[data-total]').forEach(el => { el.textContent = this.money(amount + videoAddition); });
      this.querySelector('[data-full-includes]').hidden = isMentor;
      this.querySelector('[data-package-title]').textContent = isMentor ? 'DOBRY SORT / PIERWSZA PACZKA' : 'CAŁY EBOOK / DOBRY SORT';
      this.querySelector('[data-offer-note]').textContent = isMentor ? 'Pakiet dla osób, które chcą przejść pierwszy zakup, zdjęcia i decyzje z moją pomocą.' : 'Jednorazowo. Najwięcej wartości jest w gotowej bazie hurtowni, porównaniu dostawców i rozdziałach o Vinted, których nie pokazuję publicznie na stronie.';
      if (!this.pending) {
        const buttonLabel = this.dataset.purchaseAllowed === 'true'
          ? (isMentor ? 'Kupuję pakiet Pierwsza Paczka' : 'Kupuję pełny ebook')
          : 'Sprzedaż niedostępna';
        this.button.textContent = buttonLabel;
      }
      this.querySelector('[data-free-download]').hidden = true;
      this.button.hidden = false;
      this.querySelectorAll('[data-paid-note]').forEach(el => { el.hidden = false; });
      this.querySelectorAll('[data-addon-panel], .ds-addon-pending, [data-video-paid-card]').forEach(el => { el.hidden = isMentor; });
      this.querySelectorAll('[data-video-free-card]').forEach(el => { el.hidden = false; });
      this.button.disabled = !available || this.pending;
    }
    async addToCart(event) {
      event.preventDefault();
      if (this.pending || this.button.disabled) return;
      const offer = this.selectedOffer();
      if (this.dataset.videoState === 'free' && Date.now() >= Number(this.dataset.videoEnd) * 1000) {
        this.dataset.promoExpired = 'true';
        this.status.textContent = 'Promocja na film się zakończyła. Odśwież stronę przed zakupem.';
        this.updatePrice();
        return;
      }
      const id = Number(offer.isMentor ? offer.selected?.dataset.groupId : this.variant.value);
      if (!Number.isSafeInteger(id) || id <= 0) return;
      const items = [{ id, quantity: 1 }];
      if (this.video?.checked && !this.video.disabled) {
        const videoId = Number(this.video.dataset.videoId);
        if (!Number.isSafeInteger(videoId) || videoId <= 0 || items.some(item => item.id === videoId)) return;
        items.push({ id: videoId, quantity: 1 });
      }
      this.pending = true;
      this.button.disabled = true;
      this.button.textContent = 'Dodaję…';
      this.status.textContent = '';
      this.status.removeAttribute('data-error');
      let added = false;
      try {
        const response = await fetch(this.dataset.cartAdd, {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items })
        });
        const payload = await response.json();
        if (!response.ok) throw new Error(typeof payload.description === 'string' ? payload.description : 'Nie udało się dodać produktu. Sprawdź dostępność i spróbuj ponownie.');
        added = true;
        this.status.textContent = 'Dodano. Przechodzę do koszyka…';
        window.location.assign(this.dataset.cartUrl);
      } catch (error) {
        this.status.dataset.error = 'true';
        this.status.textContent = error instanceof TypeError
          ? 'Połączenie zostało przerwane. Sprawdź koszyk przed ponownym dodaniem — produkty mogły już do niego trafić.'
          : ((error.message || 'Coś przerwało dodawanie.') + ' Sprawdź koszyk przed kolejną próbą.');
        const link = document.createElement('a');
        link.href = this.dataset.cartUrl;
        link.textContent = ' Otwórz koszyk';
        this.status.append(link);
      } finally {
        if (!added) {
          this.pending = false;
          this.button.textContent = this.defaultLabel;
          this.updatePrice();
        }
      }
    }
  }
  customElements.define('vsz-dobry-sort', DobrySort);
})();
